module.exports = __webpack_public_path__ + "img/lion_paws.149a0d04.png";